import React from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { CsmAppSidebarBoundary } from './CsmAppSidebarBoundary.tsx';

const LazyCsmAppSidebarViaResource = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebars-content-csm-app" */ './CsmAppSidebarViaResource.tsx'
		),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncCsmAppSidebar = (): React.JSX.Element => (
	<CsmAppSidebarBoundary>
		<LazyCsmAppSidebarViaResource />
	</CsmAppSidebarBoundary>
);

export default AsyncCsmAppSidebar;
